import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

import Box from '~/common/components/Box';
import Tooltip from '~/common/mui/MUITooltip/MUITooltip';

import {
  RatioHeader,
  RatioHeaderBox,
  RatioInfoBox,
  RatioInfoStackStyle,
  RatioTooltipBox,
  RatioValue,
  StyledFontAwesomeIcon,
  TooltipBox,
  TooltipRatioValue,
  TooltipStyle,
} from '../Styled';

interface RatioInfoStackProps {
  dti?: number;
  hti?: number;
  ltv?: number;
  cltv?: number;
  hcltv?: number;
}

const RatioInfoStack = ({
  dti,
  hti,
  ltv,
  cltv,
  hcltv,
}: RatioInfoStackProps) => {
  return (
    <RatioInfoStackStyle>
      <RatioInfoBox>
        <RatioHeaderBox>
          <RatioHeader>DTI</RatioHeader>
          <RatioTooltipBox>
            <Tooltip
              title={
                <TooltipBox>
                  <TooltipBox>HTI</TooltipBox>
                  <TooltipRatioValue>{hti}%</TooltipRatioValue>
                </TooltipBox>
              }
              componentsProps={{
                tooltip: { sx: TooltipStyle },
              }}
            >
              <StyledFontAwesomeIcon icon={faCircleInfo} />
            </Tooltip>
          </RatioTooltipBox>
        </RatioHeaderBox>
        <RatioValue>{dti}%</RatioValue>
      </RatioInfoBox>
      <RatioInfoBox>
        <Box>
          <RatioHeaderBox>
            <RatioHeader>LTV</RatioHeader>
            <RatioTooltipBox>
              <Tooltip
                title={
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '16px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <TooltipBox>
                      <TooltipBox>CLTV</TooltipBox>
                      <TooltipRatioValue>{cltv}%</TooltipRatioValue>
                    </TooltipBox>
                    <TooltipBox>
                      <TooltipBox>HCLTV</TooltipBox>
                      <TooltipRatioValue>{hcltv}%</TooltipRatioValue>
                    </TooltipBox>
                  </Box>
                }
                componentsProps={{
                  tooltip: { sx: TooltipStyle },
                }}
              >
                <StyledFontAwesomeIcon icon={faCircleInfo} />
              </Tooltip>
            </RatioTooltipBox>
          </RatioHeaderBox>
          <RatioValue>{ltv}%</RatioValue>
        </Box>
      </RatioInfoBox>
    </RatioInfoStackStyle>
  );
};

export default RatioInfoStack;
